class StickyProductAdd extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            productForm: "product-form",
            sectionHeader: "#shopify-section-header",
            stickyHeaderHiddenClass: "shopify-section-header-hidden",
            openClass: "open"
        }

        this.scrollElementToCheck = document.querySelector(this.selectors.productForm);
        this.sectionHeader = document.querySelector(this.selectors.sectionHeader);
        this.sectionHeaderHeight = this.sectionHeader.offsetHeight;
        this.stickyAddToCartMoved = false;
        if (!this.scrollElementToCheck) {
            return;
        }

        setTimeout(() => { this.bindEvents() }, 500);

        window.addEventListener("resize", () => {
            this.scrollElementToCheck = document.querySelector(this.selectors.productForm);
            this.sectionHeader = document.querySelector(this.selectors.sectionHeader);
            this.sectionHeaderHeight = this.sectionHeader.offsetHeight;

            this.resetTranstionProperyIfSet();
        });
    }

    bindEvents() {
        var self = this;
        window.addEventListener("scroll", function () {
            if (window.scrollY > (self.scrollElementToCheck.offsetTop + self.scrollElementToCheck.offsetHeight)) {
                if (self.isOpen() && !self.isHeaderOpen()) {
                    self.resetTranstionProperyIfSet();

                    return;
                };

                // if we have sticky bar and sticky header we move the sticky bar Y pixels down to match header
                if (self.isOpen() && self.isHeaderOpen() && !self.stickyAddToCartMoved) {
                    self.style.transform = `translateY(${self.sectionHeaderHeight - 1}px)`;
                    self.stickyAddToCartMoved = true;

                    return;
                };

                self.open();
            } else {
                self.resetTranstionProperyIfSet();

                if (!self.isOpen()) return;

                self.close();
            }

        });

        this.querySelector('a.sticky-product-add').addEventListener('click', function() {
            const button = document.querySelector('.product-form__submit');

            if(button) {
                button.click();
            }
        })
    }

    resetTranstionProperyIfSet() {
        if (this.stickyAddToCartMoved) {
            this.style.removeProperty('transform');
            this.stickyAddToCartMoved = false;
        }
    }

    isHeaderOpen() {
        return !this.sectionHeader.classList.contains(this.selectors.stickyHeaderHiddenClass)
    }

    isOpen() {
        return this.classList.contains(this.selectors.openClass);
    }

    open() {
        this.classList.add(this.selectors.openClass);
    }

    close() {
        this.classList.remove(this.selectors.openClass);
    }
}

customElements.define('sticky-product-add', StickyProductAdd);


